import LTR from "@brand-icons/global/pin-sensorial-experience-default/pin-sensorial-experience-default-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinSensorialExperienceDefaultIcon = iconFactory("PinSensorialExperienceDefaultIcon", LTR);
